import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAudioStyle0 = gravityIconIndividualCss;

const GravityIconAudio = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'c0bd3d1d2ea39853491af7c6ac72ac462257ae1b', color: this.color, size: this.size }, h("svg", { key: 'd858e2733f18b930f8680ea9aacd30fb58bd90d3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '9e13c77c11382754f4166eacb40677e423464800', d: "M15.51 4.42a.52.52 0 0 1 .72 0v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.34-.36Zm-5.34 1.29L7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37Z", fill: "currentColor" }), h("path", { key: '07fa27cfbe2a9019a93933bf7f53aa30f4199ff6', d: "m13.37 7.69-.37.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.42 3.42 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.69.05Z", fill: "currentColor" }))));
    }
};
GravityIconAudio.style = GravityIconAudioStyle0;

export { GravityIconAudio as gravity_icon_audio };

//# sourceMappingURL=gravity-icon-audio.entry.js.map